// import PeopleIcon from '@mui/icons-material/People';
import StoreIcon from '@mui/icons-material/Store';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PeopleIcon from '@mui/icons-material/People';

const pages = {
    id: 'pages',
    title: 'Cadastros',
    type: 'group',
    children: [
        {
            id: 'stores',
            title: 'Lojas',
            type: 'item',
            url: '/dashboard/stores',
            icon: StoreIcon,
            secure: true
        },
        {
            id: 'users',
            title: 'Usuários',
            type: 'item',
            url: '/dashboard/users',
            icon: PeopleIcon,
            secure: true
        },
        {
            id: 'suppliers',
            title: 'Fornecedores',
            type: 'item',
            url: '/dashboard/suppliers',
            icon: LocalShippingIcon,
            secure: true
        }
    ]
};

export default pages;
